export default "__VITE_ASSET__DlX4vFse__"